import { Container, Section } from '@resolute/ui';

import { Reveal } from '@/components/motion/reveal';
import { ProgressiveImage } from '@/components/progressive-image';

// Curl-verified royalty-free Unsplash exterior/skyline shot (same curated ID
// used by the seed's `extTowers` photo) — a growth-corridor skyline mood image.
const ORIGIN_IMAGE = 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00';

const ORIGIN_PARAGRAPHS = [
  'Property discovery in India still runs on word of mouth, unverified brokers and PDFs buried in someone’s inbox — for a decision that’s often a family’s largest investment. We watched buyers sign on developments whose RERA registration didn’t match the brochure, chase yield numbers no one could substantiate, and manage an NRI purchase entirely over WhatsApp screenshots.',
  'Resolute Property Solutions was built to close that gap — not with another listings marketplace, but with a verification-first platform. Every property carries its RERA registration and documents before it ever reaches a search result. Every yield and ROI figure is modelled, not copied from a brochure. Every NRI buyer gets the same due-diligence trail as someone walking the site in person.',
];

const ORIGIN_QUOTE =
  'We are not the biggest portal. But our verification standard is non-negotiable — on every listing, in every city we operate in.';

export function AboutOrigin() {
  return (
    <Section spacing="lg" className="bg-primary text-primary-foreground">
      <Container>
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <Reveal>
            <p className="text-sm font-medium uppercase tracking-widest text-secondary">
              Our origin
            </p>
            <h2 className="mt-2 text-balance font-display text-display-sm font-semibold tracking-tight text-primary-foreground">
              The Trust Gap We Set Out to Close.
            </h2>
            <div className="mt-4 space-y-4 text-lg text-primary-foreground/80">
              {ORIGIN_PARAGRAPHS.map((p) => (
                <p key={p.slice(0, 24)}>{p}</p>
              ))}
            </div>
            <blockquote className="mt-6 border-l-2 border-secondary pl-5 text-lg text-primary-foreground/90">
              {ORIGIN_QUOTE}
            </blockquote>
          </Reveal>

          <Reveal
            delay={0.1}
            className="overflow-hidden rounded-lg border border-primary-foreground/15"
          >
            <ProgressiveImage
              src={ORIGIN_IMAGE}
              alt="City skyline representing the growth corridors Resolute Property Solutions operates in"
              aspect="aspect-[4/3]"
              sizes="(min-width: 1024px) 560px, 100vw"
              className="w-full"
            />
            <p className="border-t border-primary-foreground/15 bg-primary-foreground/5 p-4 text-sm text-primary-foreground/70">
              Verified before it&apos;s listed. Trusted long after you move in.
            </p>
          </Reveal>
        </div>
      </Container>
    </Section>
  );
}
